<template>
  <div class="root">
    <!-- 描边 -->
    <div
      class="image-set bdline"
      v-if="config.property_data.border_spacing_type == 1"
    >
      <div
        class="flex-wra"
        @click="jump(link_data[0].link_name)"
        v-if="config.style_type == 1 && link_data.length === 1"
      >
        <div
          class="content-img"
          :class="link_data[0].image_url ? '' : 'style-1'"
        >
          <img
            :src="link_data[0].image_url || default_imgurl_border"
            :class="link_data[0].image_url ? '' : 'default-img-40'"
          />
        </div>
      </div>
      <div
        class="flex-wra"
        v-else-if="config.style_type == 2 && link_data.length === 2"
      >
        <div
          @click="jump(link_data[0].link_name)"
          class="content-img style-1-1"
        >
          <img
            :src="link_data[0].image_url || default_imgurl_border"
            :class="link_data[0].image_url ? '' : 'default-img-30'"
          />
        </div>
        <div
          @click="jump(link_data[1].link_name)"
          class="content-img bdline style-1-1"
        >
          <img
            :src="link_data[1].image_url || default_imgurl_border"
            :class="link_data[1].image_url ? '' : 'default-img-30'"
          />
        </div>
      </div>
      <div
        class="flex-wra"
        v-else-if="config.style_type == 4 && link_data.length === 3"
      >
        <div
          class="content-img bdline style-2-1 side-2"
          style="background: transparent"
        >
          <div
            @click="jump(link_data[0].link_name)"
            class="content-img bdline column-style-1-1"
            style="border-bottom: 1px solid #f0f0f0; width: 100%"
          >
            <img
              :src="link_data[0].image_url || default_imgurl_border"
              :class="link_data[0].image_url ? '' : 'default-img-25'"
            />
          </div>
          <div
            @click="jump(link_data[1].link_name)"
            class="content-img bdline column-style-1-1"
          >
            <img
              :src="link_data[1].image_url || default_imgurl_border"
              :class="link_data[1].image_url ? '' : 'default-img-25'"
            />
          </div>
        </div>
        <div
          @click="jump(link_data[2].link_name)"
          class="content-img bdline style-2-1 side-1"
          style="border-left: 1px solid #f0f0f0"
        >
          <img
            :src="link_data[2].image_url || default_imgurl_border"
            :class="link_data[2].image_url ? '' : 'default-img-30'"
          />
        </div>
      </div>
      <div
        class="flex-wra reverse"
        v-else-if="config.style_type == 3 && link_data.length === 3"
      >
        <div
          class="content-img bdline style-2-1 side-2"
          style="background: transparent"
        >
          <div
            @click="jump(link_data[1].link_name)"
            class="content-img bdline column-style-1-1"
            style="border-bottom: 1px solid #f0f0f0; width: 100%"
          >
            <img
              :src="link_data[1].image_url || default_imgurl_border"
              :class="link_data[1].image_url ? '' : 'default-img-25'"
            />
          </div>
          <div
            @click="jump(link_data[2].link_name)"
            class="content-img bdline column-style-1-1"
          >
            <img
              :src="link_data[2].image_url || default_imgurl_border"
              :class="link_data[2].image_url ? '' : 'default-img-25'"
            />
          </div>
        </div>
        <div
          @click="jump(link_data[0].link_name)"
          class="content-img bdline style-2-1 side-1"
        >
          <img
            :src="link_data[0].image_url || default_imgurl_border"
            :class="link_data[0].image_url ? '' : 'default-img-30'"
          />
        </div>
      </div>
      <div
        class="flex-wra"
        v-else-if="config.style_type == 5 && link_data.length === 3"
      >
        <div
          @click="jump(link_data[0].link_name)"
          class="content-img style-1-1-1"
        >
          <img
            :src="link_data[0].image_url || default_imgurl_border"
            :class="link_data[0].image_url ? '' : 'default-img-25'"
          />
        </div>
        <div
          @click="jump(link_data[1].link_name)"
          class="content-img style-1-1-1"
        >
          <img
            :src="link_data[1].image_url || default_imgurl_border"
            :class="link_data[1].image_url ? '' : 'default-img-25'"
          />
        </div>
        <div
          @click="jump(link_data[2].link_name)"
          class="content-img bdline style-1-1-1"
        >
          <img
            :src="link_data[2].image_url || default_imgurl_border"
            :class="link_data[2].image_url ? '' : 'default-img-25'"
          />
        </div>
      </div>
      <div
        class="flex-wra"
        v-else-if="config.style_type == 6 && link_data.length === 4"
      >
        <div
          @click="jump(link_data[0].link_name)"
          class="content-img style-1-1-1-1"
        >
          <img
            :src="link_data[0].image_url || default_imgurl_border"
            :class="link_data[0].image_url ? '' : 'default-img-25'"
          />
        </div>
        <div
          @click="jump(link_data[1].link_name)"
          class="content-img style-1-1-1-1"
        >
          <img
            :src="link_data[1].image_url || default_imgurl_border"
            :class="link_data[1].image_url ? '' : 'default-img-25'"
          />
        </div>
        <div
          @click="jump(link_data[2].link_name)"
          class="content-img style-1-1-1-1"
        >
          <img
            :src="link_data[2].image_url || default_imgurl_border"
            :class="link_data[2].image_url ? '' : 'default-img-25'"
          />
        </div>
        <div
          @click="jump(link_data[3].link_name)"
          class="content-img bdline style-1-1-1-1"
        >
          <img
            :src="link_data[3].image_url || default_imgurl_border"
            :class="link_data[3].image_url ? '' : 'default-img-25'"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { redirectURL } from "@/js/jump";
export default {
  name: "tms-image_list",
  props: ["config", "theme", "isEditorStatus"],
  data() {
    return {
      default_imgurl:
        "https://img.mockuai.com/tms/2018/1/10/upload_48dfb5b82f032311cb9207f142a95b89.png",
      default_imgurl_border:
        "https://img.mockuai.com/tms/2018/1/13/upload_ed4e75f3608d59cbd803c5e3a98960af.png",
    };
  },

  components: {},

  mounted() {
    this.page_id = this.$route.query.page_id;
  },
  computed: {
    link_data() {
      return this.config.link_data || {};
    },
    style_type() {
      return this.config.style_type;
    },
    property_data() {
      return this.config.property_data;
    },
  },
  methods: {
    jump(item) {
      if (this.isEditorStatus || !item) {
        return;
      }
      redirectURL(item.toString(), "seller");
    },
  },
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>